enum AbsenceTypeEnum {
    HOLIDAY = 'HOLIDAY',
    REMOTE = 'REMOTE',
    SICK_LEAVE = 'SICK_LEAVE'
}

export default AbsenceTypeEnum;
